import { FieldPattern } from '..';

import { COUNTRY_ASYNC_SELECT } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class CountriesComboBoxField extends DependentField {
  readonly type: string = COUNTRY_ASYNC_SELECT;
  searchKey: string;
  enableDefaultSuggestion: boolean;
  dependentFields: Array<string>;
  isFieldDisabled: boolean;
  mobilePlaceholder: string;

  constructor(stateFieldData: FormFieldsType, initialValue: string) {
    super(stateFieldData, initialValue);
    this.searchKey = stateFieldData.search_key ?? '';
    this.enableDefaultSuggestion =
      stateFieldData.enable_default_suggestion ?? false;
    this.dependentFields = stateFieldData.dependent_fields ?? [];
    this.isFieldDisabled = false;
    this.mobilePlaceholder = stateFieldData.mobile_placeholder ?? '';
    if (stateFieldData.default_value) {
      this.initialValue = stateFieldData.default_value;
    }
  }

  match<T>(p: FieldPattern<T>): T {
    return p.CountriesComboBoxField(this);
  }
}

export default CountriesComboBoxField;
